import React from 'react';
import { ContentComparisonSliderSC as T } from './ContentComparisonSliderSC';
import { Icon, Tooltip } from 'imaginarity-react-ui';
import { useImgI18N } from 'services/ImgI18N';

interface SliderHandleProps {
    orientation: 'horizontal' | 'vertical';
    sliderPosition: number;
    allowSlideByGrab: boolean;
    handleMouseDown: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    onClick?: () => void; // Callback hinzufügen
    locked: boolean;
    noContextMenu?: boolean;

}

const SliderHandle = (p: SliderHandleProps) => {
    const { orientation, sliderPosition, allowSlideByGrab, handleMouseDown, onClick, locked, noContextMenu } = p;
    const sliderIsVertical = orientation === 'vertical';
    const { t } = useImgI18N("slideshow");

    return (
        <div style={{ pointerEvents: locked ? "none" : "all" }}>
            <T.SliderLine
                top={sliderIsVertical ? "0%" : `${sliderPosition}%`}
                left={sliderIsVertical ? `${sliderPosition}%` : "0%"}
                width={sliderIsVertical ? "1px" : "calc(50% - 20px)"}
                height={sliderIsVertical ? "calc(50% - 20px)" : "1px"}
                onMouseDown={allowSlideByGrab ? handleMouseDown : undefined}
                locked={locked}
            />
            <T.SliderLine
                top={sliderIsVertical ? "calc(50% + 20px)" : `${sliderPosition}%`}
                left={sliderIsVertical ? `${sliderPosition}%` : "calc(50% + 20px)"}
                width={sliderIsVertical ? "1px" : "calc(50% + 20px)"}
                height={sliderIsVertical ? "calc(50% - 20px)" : "1px"}
                onMouseDown={allowSlideByGrab ? handleMouseDown : undefined}
                locked={locked}
            />
            <T.SliderButton
                top={sliderIsVertical ? "50%" : `${sliderPosition}%`}
                left={sliderIsVertical ? `${sliderPosition}%` : "50%"}
                onMouseDown={allowSlideByGrab ? handleMouseDown : undefined}

                locked={locked}
            >
                {locked ? (
                    <T.SliderButtonIcon onClick={onClick}>
                        <Tooltip tooltipText={noContextMenu ? t("unlock slider") : t('disable pointer events')}  >
                            <span>
                                <Icon name="lock" color="@mainBackground" size="20px" marginTop={2} />
                            </span>
                        </Tooltip>
                    </T.SliderButtonIcon>
                ) : (
                    <>
                        <T.SliderButtonArrow pos="right" sliderIsVertical={sliderIsVertical} />
                        <T.SliderButtonArrow pos="left" sliderIsVertical={sliderIsVertical} />
                    </>
                )}
            </T.SliderButton>
        </div>
    );
};

export default SliderHandle;
